<!--<div class="pagebrk"></div>
  <printheaderview>
  </printheaderview>-->
<div class="row">
  <div class="col-print-12 padding-left-0px">
    <div class="card background-color-wt">
      <div class="card-header background-color-wt padding-left-0px border-bottom-0 padding-top-0px padding-bottom-0px"></div>
      <div class="card-body padding-top-10px padding-bottom-0px font-weight-normal background-color-wt">

        <div class="row">
          <div class="col-print-12 text-align-center">
            <label class="font-familyhead">Prescription</label>
            <!--<qrcode class="padding-top-0px padding-bottom-0px qr-style7" [qrdata]="FormattedCodedata" [size]="90" [level]="'M'"></qrcode>-->
          </div>
        </div>

        <div class="col-print-12 bordertop border-bot-1px border-bottom-1px" *ngFor="let l of CurrentPatientInfoByFormattedCodeController">
          <div class="row margin-left-0px margin-right-0px">
            <div class="col-print-6 margin-top-10 margin-bottom-10px">
              <!--<div class="row margin-left-0px margin-right-0px">
                <div class="col-print-4">
                  <label class="margin-bottom-0px font-family font-weight-normal">Patient:</label>
                </div>
                <div class="col-print-8">
                  <label class="margin-bottom-0px font-family float-left font-weight-bold">{{l.DisplayName}}</label>
                </div>
              </div>
              <div class="row margin-left-0px margin-right-0px">
                <div class="col-print-4">
                  <label class="margin-bottom-0px font-family font-weight-normal">Patient ID:</label>
                </div>
                <div class="col-print-8">
                  <label class="margin-bottom-0px font-family float-left font-weight-normal">{{l.FormattedCode}}</label>
                </div>
              </div>-->
              <div class="row margin-left-0px margin-right-0px">
                <div class="col-print-4">
                  <label class="margin-bottom-0px font-family font-weight-normal">Doctor:</label>
                </div>
                <div class="col-print-8" *ngIf="DoctorDetailsData">
                  <label class="margin-bottom-0px font-family float-left font-weight-normal">{{DoctorDetailsData.SignAuthority}}</label>
                </div>
              </div>
            </div>

            <div class="col-print-1"></div>

            <div class="col-print-5 margin-top-10 margin-bottom-10px">
              <!--<div class="row margin-left-0px margin-right-0px">
                <div class="col-print-4">
                  <label class="margin-bottom-0px font-family font-weight-normal">Gender/Age:</label>
                </div>
                <div class="col-print-8">
                  <label class="margin-bottom-0px font-family float-right font-weight-normal">{{l.Gender}}/{{l.Age}}</label>
                </div>
              </div>-->
              <div class="row margin-left-0px margin-right-0px">
                <div class="col-print-4">
                  <label class="margin-bottom-0px font-family font-weight-normal">Branch:</label>
                </div>
                <div class="col-print-8">
                  <label class="margin-bottom-0px font-family float-left font-weight-normal">{{l.FacilityName}}</label>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!--<div class="col-print-12">
    <div class="row margin-left-0px margin-right-0px">
      <div class="col-print-2">
        <label class="margin-bottom-0px font-family font-weight-normal"></label>
      </div>
      <div class="col-print-6">
        <label class="margin-bottom-0px font-family float-left font-weight-normal"></label>
      </div>
    </div>
  </div>-->

        <div class="col-print-12">
          <div class="row margin-right-0px margin-left-0px">
            <div class="col-print-12">
              <div class="table-component margin-bottom-0px border4">
                <div class="table-responsive">
                  <table class="table table-striped margin-left-zero">
                    <thead>
                      <tr>

                        <th class="font-weight-normal background-primary padding-top-2px padding-bottom-2px font-family width-35px text-align-center">
                          #
                        </th>

                        <th class="font-weight-normal background-primary text-align-left padding-top-2px padding-bottom-2px font-family">
                          Medicine Details
                        </th>
                        <!--<th class="font-weight-normal background-primary text-align-center padding-top-2px padding-bottom-2px font-family">
                    Prescriber
                  </th>-->
                        <th class="font-weight-normal background-primary text-align-right padding-top-2px padding-bottom-2px font-family">
                          Frequency
                        </th>
                        <th class="font-weight-normal background-primary text-align-right padding-top-2px padding-bottom-2px font-family">
                          Date/duration
                        </th>

                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let l of CurrentClinicalOrderRxItemsController;let RowIndex = index">
                        <td class="font-family padding-top-2px padding-bottom-2px text-align-center">{{RowIndex+1}}</td>
                        <td class="font-family padding-top-2px padding-bottom-2px text-align-left">
                          <div *ngIf="!l.IsStopped">{{l.GenericMedicineName}}</div>
                          <div *ngIf="!l.IsStopped">{{l.Dose}}{{l.DurationType}},{{l.Route}}</div>
                          <div *ngIf="!l.IsStopped">{{l.Instructions}}</div>
                          <div *ngIf="l.IsStopped"><s>{{l.GenericMedicineName}}</s></div>
                          <div *ngIf="l.IsStopped"><s>{{l.Dose}}{{l.DurationType}},{{l.Route}}</s></div>
                          <div *ngIf="l.IsStopped"><s>{{l.Instructions}}</s></div>
                        </td>

                        <td class="font-family padding-top-2px padding-bottom-2px text-align-right" *ngIf="!l.IsStopped">{{l.Frequency}}</td>
                        <td class="font-family padding-top-2px padding-bottom-2px text-align-right" *ngIf="l.IsStopped"><s>{{l.Frequency}}</s></td>

                        <td class="font-family padding-top-2px padding-bottom-2px text-align-right" *ngIf="l.StartDate!=l.EndDate">{{l.StartDate| date:'dd-MMM-yyyy'}} to {{l.EndDate| date:'dd-MMM-yyyy'}}</td>
                        <td class="font-family padding-top-2px padding-bottom-2px text-align-right" *ngIf="l.StartDate==l.EndDate">{{l.StartDate| date:'dd-MMM-yyyy'}}</td>
                      </tr>
                    </tbody>
                  </table>

                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-print-12 background-color-wt">
          <div class="row margin-left-0px margin-right-0px">
            <div class="col-print-6">
              <label class="margin-bottom-0px font-family"></label>
            </div>
            <div class="col-print-6">
              <label class="margin-bottom-0px font-family"></label>
            </div>
          </div>
          <div class="card background-color-wt">

            <div class="card-header background-color-wt border-bottom-0px">

            </div>
            <div class="card-body background-color-wt padding-top-0px padding-bottom-0px">
              <div class="row">
                <div class="col-print-9 float-left">
                  <!--<qrcode [qrdata]="FormattedCode" [width]="125" [errorCorrectionLevel]="'M'"></qrcode>-->
                </div>
                <div class="col-print-3">
                  <div class="row">
                    <label class="margin-bottom-0px font-familysubhead">Signature</label>
                  </div>
                  <div class="row" *ngIf="DoctorDetailsData">
                    <label class="margin-bottom-0px font-family font-weight-bold">{{DoctorDetailsData.SignAuthority}}</label>
                  </div>                  
                </div>
              </div>

            </div>

          </div>

        </div>

      </div>
    </div>
  </div>
</div>
<!--<printfooterview></printfooterview>-->
